import React from 'react';
import {
  FormLabel,
  Icon,
  IconButton,
  InputGroup,
  InputRightElement,
} from '@podiumhq/design-system';
import styled from 'styled-components/macro';

import {
  FormElementsInputErrorMessage,
  FormElementsInputWrapper,
} from './styles';

export const FormFieldWrapper = ({
  children,
  displayErrorIcon = true,
  error,
  id,
  inputGroupSize = 'md',
  label,
  ...boxProps
}) => {
  const { iconProps, ...wrapperProps } = boxProps;
  return (
    <FormElementsInputWrapper
      error={error}
      id={`${id}-form-wrapper`}
      {...wrapperProps}
    >
      {label && <FormLabel htmlFor={id}>{label}</FormLabel>}

      <InputGroup size={inputGroupSize}>
        {children}

        {!iconProps && displayErrorIcon && error && (
          <StyledRightElement size={boxProps?.size}>
            <Icon
              sx={{ svg: { fill: 'red.base' } }}
              size="sm"
              type="AlertCircle"
              variant="ghost"
            />
          </StyledRightElement>
        )}

        {iconProps && (
          <StyledRightElement size={boxProps?.size}>
            <IconButton
              type={iconProps.icon}
              onClick={iconProps.onClick}
              size="sm"
              fillColor="silver.light"
              variant="ghost"
              sx={{ svg: { fill: 'silver.light' } }}
              tabIndex={-1}
            />
          </StyledRightElement>
        )}
      </InputGroup>

      {error && (
        <FormElementsInputErrorMessage>{error}</FormElementsInputErrorMessage>
      )}
    </FormElementsInputWrapper>
  );
};

const StyledRightElement = styled(InputRightElement)`
  margin-top: ${({ size }) => (size === 'lg' ? '5px' : '0px')};
`;
